import {
  ActionIcon,
  Box,
  Button,
  Group,
  Modal,
  Stack,
  Text
} from "@mantine/core";
import React, { useState } from "react";
import { FaPlus, FaTrash, FaWrench } from "react-icons/fa";
import { FaPencil } from "react-icons/fa6";
import { useAuth } from "../../contexts/auth.context";
import { useLanguage } from "../../contexts/language.context";
import InputField, { InputFieldTypes } from "../input_field";

export default function OthersSettings({ data, setData }: any) {
  const { str, lang } = useLanguage();

  const [updatingPronunciation, setUpdatingPronunciation] = useState<any>(null);
  const { userData } = useAuth();

  const handleSavePronunciation = () => {
    const { index, data } = updatingPronunciation;

    if ([null, undefined].includes(index)) {
      setData((na: any) => ({
        ...na, data: {
          ...na.data, retell: {
            ...na?.data?.retell, agent: {
              ...na?.data?.retell?.agent,
              pronunciation_dictionary: [...(na?.data?.retell?.agent?.pronunciation_dictionary ?? []), data]
            }
          }
        }
      }))
    } else {
      setData((na: any) => ({
        ...na, data: {
          ...na.data, retell: {
            ...na?.data?.retell, agent: {
              ...na?.data?.retell?.agent,
              pronunciation_dictionary: (na?.data?.retell?.agent?.pronunciation_dictionary ?? []).map((p: any, i) =>
                (i === index)
                  ? {
                    ...p,
                    ...data,
                  }
                  : p
              )
            }
          }
        }
      }))
    }
    setUpdatingPronunciation(null);
  }

  return <>
    <Stack>
      <Group>
        <FaWrench />
        <Text size="lg" fw="bold" style={{ flex: 1 }} c="gray.0">{str("AGENTS.VOICE_SETTINGS")}</Text>
      </Group>

      {/* <InputField
        name="llm_websocket_url"
        title="llm_websocket_url"
      
        value={data?.data?.retell?.agent?.llm_websocket_url}
        onChange={({llm_websocket_url}) => setData((na: any) => ({...na, data: { ...na.data, retell: {
          ...na?.data?.retell, agent: { ...na?.data?.retell?.agent, llm_websocket_url } } } }))}
      /> */}

      {/* <InputField
        name="agent_name"
        title="agent_name"
      
        value={data?.data?.retell?.agent?.agent_name}
        onChange={({agent_name}) => setData((na: any) => ({...na, data: { ...na.data, retell: {
          ...na?.data?.retell, agent: { ...na?.data?.retell?.agent, agent_name } } } }))}
      /> */}

      <InputField
        name="voice_temperature"
        title={`${str('AGENTS.TONE_OF_VOICE')} (${parseFloat(data?.data?.retell?.agent?.voice_temperature ?? 1).toFixed(2)})`}
        mb="xl"
        fieldType={InputFieldTypes.SLIDE}
        min={1}
        marks={[
          { label: "Calm", value: 1 },
          { label: "Emotional", value: 100 },
        ]}
        value={(data?.data?.retell?.agent?.voice_temperature ?? 1) * 100 / 2}
        onChange={({ voice_temperature }) => setData((na: any) => ({
          ...na, data: {
            ...na.data, retell: {
              ...na?.data?.retell, agent: { ...na?.data?.retell?.agent, voice_temperature: voice_temperature * 2 / 100 }
            }
          }
        }))}
      />

      <InputField
        name="voice_speed"
        title={`${str('AGENTS.VOICE_SPEED')} (${parseFloat(data?.data?.retell?.agent?.voice_speed ?? 1).toFixed(2)})`}
        mb="xl"
        fieldType={InputFieldTypes.SLIDE}
        min={25}
        marks={[
          { label: "Slow", value: 25 },
          { label: "Fast", value: 100 },
        ]}
        value={(data?.data?.retell?.agent?.voice_speed ?? 1) * 100 / 2}
        onChange={({ voice_speed }) => setData((na: any) => ({
          ...na, data: {
            ...na.data, retell: {
              ...na?.data?.retell, agent: { ...na?.data?.retell?.agent, voice_speed: voice_speed * 2 / 100 }
            }
          }
        }))}
      />

      <InputField
        name="volume"
        title={`${str('AGENTS.VOLUME')} (${parseFloat(data?.data?.retell?.agent?.volume ?? 1).toFixed(2)})`}
        mb="xl"
        fieldType={InputFieldTypes.SLIDE}
        min={25}
        marks={[
          { label: "Low", value: 25 },
          { label: "Loud", value: 100 },
        ]}
        value={(data?.data?.retell?.agent?.volume ?? 1) * 100 / 2}
        onChange={({ volume }) => setData((na: any) => ({
          ...na, data: {
            ...na.data, retell: {
              ...na?.data?.retell, agent: { ...na?.data?.retell?.agent, volume: volume * 2 / 100 }
            }
          }
        }))}
      />

      <InputField
        name="responsiveness"
        title={`${str('AGENTS.RESPONSIVENESS')} (${parseFloat(data?.data?.retell?.agent?.responsiveness ?? 1).toFixed(2)})`}
        mb="xl"
        fieldType={InputFieldTypes.SLIDE}
        marks={[
          { label: "Slow", value: 0 },
          { label: "Fast", value: 100 },
        ]}
        value={(data?.data?.retell?.agent?.responsiveness ?? 1) * 100}
        onChange={({ responsiveness }) => setData((na: any) => ({
          ...na, data: {
            ...na.data, retell: {
              ...na?.data?.retell, agent: { ...na?.data?.retell?.agent, responsiveness: responsiveness / 100 }
            }
          }
        }))}
      />

      <InputField
        name="interruption_sensitivity"
        title={`${str('AGENTS.INTERRUPTION_SENSITIVITY')} (${parseFloat(data?.data?.retell?.agent?.interruption_sensitivity ?? 1).toFixed(2)})`}
        mb="xl"
        fieldType={InputFieldTypes.SLIDE}
        marks={[
          { label: str('LOW'), value: 0 },
          { label: str('HIGH'), value: 100 },
        ]}
        value={(data?.data?.retell?.agent?.interruption_sensitivity ?? 1) * 100}
        onChange={({ interruption_sensitivity }) => setData((na: any) => ({
          ...na, data: {
            ...na.data, retell: {
              ...na?.data?.retell, agent: { ...na?.data?.retell?.agent, interruption_sensitivity: interruption_sensitivity / 100 }
            }
          }
        }))}
      />
      
      <InputField
        name="max_call_duration"
        title={`${str('AGENTS.MAX_CALL_DURATION')} (${parseFloat(data?.data?.retell?.agent?.max_call_duration ?? 60)} min)`}
        mb="xl"
        fieldType={InputFieldTypes.SLIDE}
        marks={[
          { label: str('MIN'), value: 1 },
          { label: str('MAX'), value: 120 },
        ]}
        min={1}
        max={120}
        value={(data?.data?.retell?.agent?.max_call_duration ?? 60)}
        onChange={({ max_call_duration }) => setData((na: any) => ({
          ...na, data: {
            ...na.data, retell: {
              ...na?.data?.retell, agent: { ...na?.data?.retell?.agent, max_call_duration: max_call_duration }
            }
          }
        }))}
      />
      
      <InputField
        name="ring_duration"
        title={`${str('AGENTS.RING_DURATION')} (${parseFloat(data?.data?.retell?.agent?.ring_duration ?? 30)}s)`}
        mb="xl"
        fieldType={InputFieldTypes.SLIDE}
        marks={[
          { label: str('MIN'), value: 5 },
          { label: str('MAX'), value: 90 },
        ]}
        min={5}
        max={90}
        value={(data?.data?.retell?.agent?.ring_duration ?? 30)}
        onChange={({ ring_duration }) => setData((na: any) => ({
          ...na, data: {
            ...na.data, retell: {
              ...na?.data?.retell, agent: { ...na?.data?.retell?.agent, ring_duration: ring_duration }
            }
          }
        }))}
      />

      <InputField
        name="enable_backchannel"
        title={str("AGENTS.BACKCHANNEL_TITLE")}

        fieldType={InputFieldTypes.SWITCH}
        value={data?.data?.retell?.agent?.enable_backchannel}
        onChange={({ enable_backchannel }) => setData((na: any) => ({
          ...na, data: {
            ...na.data, retell: {
              ...na?.data?.retell, agent: { ...na?.data?.retell?.agent, enable_backchannel }
            }
          }
        }))}
      />
      <Text size="xs" c="gray.3">{str("AGENTS.BACKCHANNEL_SUBTITLE")}</Text>

      <InputField
        name="end_call_after_silence"
        title={str("AGENTS.END_CALL_AFTER_SILENCE_TITLE")}

        fieldType={InputFieldTypes.NUMBER}
        min={10}
        value={data?.data?.retell?.agent?.end_call_after_silence ?? 30}
        onChange={({ end_call_after_silence }) => setData((na: any) => ({
          ...na, data: {
            ...na.data, retell: {
              ...na?.data?.retell, agent: { ...na?.data?.retell?.agent, end_call_after_silence }
            }
          }
        }))}
      />
      <Text size="xs" c="gray.3">{str("AGENTS.END_CALL_AFTER_SILENCE_SUBTITLE")}</Text>

      <InputField
        name="boosted_keywords"
        title={str("AGENTS.BOOSTED_KEYWORDS_TITLE")}

        value={data?.data?.retell?.agent?.boosted_keywords}
        onChange={({ boosted_keywords }) => setData((na: any) => ({
          ...na, data: {
            ...na.data, retell: {
              ...na?.data?.retell, agent: { ...na?.data?.retell?.agent, boosted_keywords }
            }
          }
        }))}
      />
      <Text size="xs" c="gray.3">{str("AGENTS.BOOSTED_KEYWORDS_SUBTITLE")}</Text>

      <Box>
        <Group>
          <Text flex={1} size="sm" w="bold" c="gray.3">{str("AGENTS.PRONUNCIATION_TITLE")}</Text>
          <ActionIcon onClick={() => setUpdatingPronunciation({ index: null, data: {} })} size="xs"><FaPlus /></ActionIcon>
        </Group>
        {
          (data?.data?.retell?.agent?.pronunciation_dictionary ?? []).map((pr: any, i: number) => (
            <Group>
              <Text>{pr.word}</Text>
              <Text>{pr.phoneme}</Text>
              <ActionIcon
                onClick={() => {
                  setUpdatingPronunciation({
                    index: i,
                    data: pr,
                  })
                }}
                size="xs"><FaPencil /></ActionIcon>
              <ActionIcon
                onClick={() => {
                  setData((na: any) => ({
                    ...na, data: {
                      ...na.data, retell: {
                        ...na?.data?.retell, agent: {
                          ...na?.data?.retell?.agent,
                          pronunciation_dictionary: na?.data?.retell?.agent?.pronunciation_dictionary?.filter((p: any, j: number) => i !== j)
                        }
                      }
                    }
                  }))
                }}
                size="xs"><FaTrash /></ActionIcon>
            </Group>
          ))
        }
      </Box>
      <Text size="xs" c="gray.3">{str("AGENTS.PRONUNCIATION_SUBTITLE")}</Text>

      {/* {userData?.user?.isAdmin && <InputField
      fieldType={InputFieldTypes.SWITCH}
      name="own"
      title="Use AWS Servers"
      value={data?.data?.own}
      onChange={({ own }) => setData((na: any) => ({ ...na, data: { ...na.data, own } }))}
    />} */}


      {/* <Group>
        <Text fw="bold" style={{flex: 1}}>Variables</Text>
        <ActionIcon
          onClick={() => { setData((na: any) => ({ ...na, data: { ...na?.data, variables: [...(na?.data?.variables ?? []), { type: "string" }] } })) }}
        ><FaPlus/></ActionIcon>
      </Group>
      
      {(data?.data?.variables ?? []).map((v, vi) => <Group>
        <InputField
          name="key"
          title="Key"
        
          style={{flex: 1}}
          value={v?.key}
          onChange={({key}) => {
            setData((na: any) => ({ ...na, data: { ...na?.data, variables: na.data?.variables.map((v2, vj) => vi === vj ? {...v2, key} : v2) } }))
          }}
        />
        <InputField
          name="title"
          title="Title"
        
          style={{flex: 1}}
          value={v?.title}
          onChange={({title}) => {
            setData((na: any) => ({ ...na, data: { ...na?.data, variables: na.data?.variables.map((v2, vj) => vi === vj ? {...v2, title} : v2) } }))
          }}
        />
      </Group>)} */}
    </Stack>

    <Modal
      opened={!!updatingPronunciation}
      onClose={() => setUpdatingPronunciation(null)}
    >
      <Stack>
        <InputField
          name="word"
          placeholder={str("AGENTS.PRONUNCIATION_WORD")}
          value={updatingPronunciation?.data?.word}
          onChange={({ word }) => setUpdatingPronunciation((up: any) => ({ ...up, data: { ...up?.data, word } }))}
        />
        <InputField
          name="alphabet"
          value={updatingPronunciation?.data?.alphabet ?? "ipa"}
          placeholder={str("AGENTS.PRONUNCIATION_ALPHABET")}
          fieldType={InputFieldTypes.SELECT}
          onChange={({ alphabet }) => setUpdatingPronunciation((up: any) => ({ ...up, data: { ...up?.data, alphabet } }))}
          options={[
            { value: "ipa", label: "IPA" },
            { value: "cmu", label: "CMU" },
          ]}
        />
        <InputField
          name="phoneme"
          value={updatingPronunciation?.data?.phoneme}
          placeholder={str("AGENTS.PRONUNCIATION_PHONEME")}
          onChange={({ phoneme }) => setUpdatingPronunciation((up: any) => ({ ...up, data: { ...up?.data, phoneme } }))}
        />
        <Group justify="flex-end">
          <Button
            variant="transparent"
            onClick={() => window.open(`https://tophonetics.com/${lang.split("-")[0]}`, "_blank")}
          >{str("GENERATE")}</Button>
          <Button onClick={handleSavePronunciation} disabled={!updatingPronunciation?.data?.word || !updatingPronunciation?.data?.phoneme}>{str("SAVE")}</Button>
        </Group>
      </Stack>
    </Modal>
  </>
}